/**
 * https://www.fia.gov.tw/singlehtml/3?cntId=c4d9cff38c8642ef8872774ee9987283
 * 統一編號檢查碼邏輯文件
 */

const INDEX_OF_NUMBER_7 = 6;
const LOGIC_MULTIPLIERS = [1, 2, 1, 2, 1, 2, 4, 1];

export const taxIdNumberLogicStrategy = (value: string) => {
  if (!value.match('[0-9]{8}')) return false;

  const numbers = value.split('');
  const number7 = numbers[INDEX_OF_NUMBER_7];

  if (number7 === '7') {
    const z1 = getSum(numbers, 0);
    const z2 = getSum(numbers, 1);

    return checkIsSumValid(z1) || checkIsSumValid(z2);
  }
  const z = getSum(numbers);

  return checkIsSumValid(z);
};

function checkIsSumValid(sum: number): boolean {
  return sum % 5 === 0;
}

function getSum(numbers: string[], specifiedNumber7?: 0 | 1) {
  return numbers.reduce((acc, cur, index) => {
    const number = +cur;
    const multiplier = LOGIC_MULTIPLIERS[index];
    const product = number * multiplier;

    let sum =
      product >= 10 ? Math.floor(product / 10) + (product % 10) : product;

    if (index === INDEX_OF_NUMBER_7 && !!specifiedNumber7) {
      sum = specifiedNumber7;
    }

    return acc + sum;
  }, 0);
}
